import { render, staticRenderFns } from "./PopularReview.vue?vue&type=template&id=71548a4c&scoped=true&"
import script from "./PopularReview.vue?vue&type=script&lang=js&"
export * from "./PopularReview.vue?vue&type=script&lang=js&"
import style0 from "./PopularReview.vue?vue&type=style&index=0&id=71548a4c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71548a4c",
  null
  
)

export default component.exports